/* PEONLY Exklusiv: Mengen in 25er-Schritten.
   Felder mit data-pe-step werden bei Eingabe und beim Absenden auf ein Vielfaches des Schritts gerundet (mindestens ein Schritt).
   Im Warenkorb bleibt 0 erhalten, weil 0 dort die Position entfernt. +/- Buttons nutzen das step-Attribut (quantity-input.min.js). */
(function () {
  function snap(input, force) {
    var step = parseInt(input.getAttribute('data-pe-step'), 10) || 25;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) { v = step; }
    if (v <= 0) {
      if (!force) { return; }
      v = step;
    }
    var r = Math.round(v / step) * step;
    if (r < step) { r = step; }
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && max >= step && r > max) { r = Math.floor(max / step) * step; }
    if (String(r) !== String(input.value)) { input.value = r; }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-pe-step]')) { snap(t, false); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelectorAll) { return; }
    f.querySelectorAll('input[data-pe-step]').forEach(function (i) { snap(i, true); });
  }, true);
})();
